<template lang="html">
  <v-container fluid>
    <v-toolbar dense dark tile flat class="title text-center text-md-left">
      How many can we expect of each?
    </v-toolbar>
    <v-row dense>
      <v-col cols="4">
        <v-text-field
          label="Adult males"
          v-model="event.overnight.males.adult"
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Males 12 - 17"
          v-model="event.overnight.males.twelveToSeventeen"
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Males 0 - 11"
          v-model="event.overnight.males.zeroToEleven"
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Adult females"
          v-model="event.overnight.females.adult"
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Females 12 - 17"
          v-model="event.overnight.females.twelveToSeventeen"
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col cols="4">
        <v-text-field
          label="Females 0 - 11"
          v-model="event.overnight.females.zeroToEleven"
          color="secondary"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          label="Does Your Group Have Any Special Needs?"
          v-model="event.overnight.specialNeeds"
          color="secondary"
        >
        </v-text-field>
      </v-col>
      <v-col  cols="12" md="6">
        <v-text-field
          label="How Did You Hear About Us?"
          v-model="event.overnight.referralInfo"
          color="secondary"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    eventInfo : Object
  },
  data(){
    return {
      event : this.eventInfo,
    }
  },
}
</script>

<style lang="css" scoped>
</style>
